export default "__VITE_ASSET__BvjWyRvG__"